import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.image-card-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--image-card-slider' )[0], {
          pagination: false,
          arrows: true,
          gap: '24px',
          autoWidth: true,
          breakpoints: {
            1023: {
              perPage: 1,
              autowidth: false,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-card-slider', COMPONENT );
} )( app );
